import actions from './actions'
import saga from '../../GeneralListFunctions/sagaFactory'

export default () =>
  saga(actions, () => '/v1/auth/organization/{id:[0-9]+}/managing/relations', state => state.organization.crud.object.organizations)
